import { DatePicker, Form, Input, Select, Tag } from 'antd';
import { observer } from 'mobx-react'
import PageWrapper from 'pages/Components/PageWrapper';
import { useCallback, useEffect, useRef, useState } from 'react'
import CustomButton from 'base/ui/components/Button';
import { CheckStatus, CloseStatus, Filter } from 'base/ui/components/Icons';
import BoxContainer from 'base/ui/components/BoxContainer';
import { SearchBox, SearchForm, SearchItem } from 'pages/Components/SearchBox';
import CustomProTable, { tablePagination } from 'base/ui/components/CustomTable';
import SaveReportForm from 'pages/Components/reportForm';
import { ActionType, ProColumns } from '@ant-design/pro-components';
import { useResizableColumns } from 'utils/reportHelper';
import { DATE_FORMAT_DEFAULT, PAGE_SIZE_DEFAULT, SYSTEM_TITLE } from 'utils/constants';
import { ExportButton } from 'pages/Components/FunctionButton';
import { commonPresenter, commonStore, reportPresenter, reportStore } from 'stores/root_store';
import dayjs from 'dayjs';
import { WasteHandoverRegistrationReport } from 'models/Report';
import { SearchWasteHandoverRegistrationReport } from 'services/Main/report_services';
import { checkPermissionWithId } from 'utils/permissionHelper';
import { usePermission } from 'hooks/usePermission';
import { HiSearch } from 'react-icons/hi';
import { CommonModel } from 'services/Main/common_services';
import { debounce } from 'utils/debounce';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { ROUTES } from 'base/routes/routes';
import { cloneDeep } from 'lodash';
import { removeEmptyValues } from 'utils/transformHelper';

const dropdownActive = [{
  label: 'Đang hoạt động',
  value: true
}, {
  label: "Hủy phiếu",
  value: false
}]

const initialSearch: SearchWasteHandoverRegistrationReport = {
  paging: {
    pageSize: PAGE_SIZE_DEFAULT,
    pageIndex: 1,
    orderBy: undefined,
    orderByDesc: undefined,
  },
  deliveryDateFrom: dayjs().startOf('month').format('YYYY-MM-DD'),
  deliveryDateTo: dayjs().endOf('month').format('YYYY-MM-DD'),
}
// BC05 - Báo cáo danh sách xe vào lấy chất thải
const createListRegistrationWaste = () => {
  return observer(() => {
    document.title = 'Báo cáo - ' + SYSTEM_TITLE;
    usePermission('INDEX')
    const isExport = checkPermissionWithId("EXPORT")

    // ========== SEARCH =================
    const [searchForm] = Form.useForm()
    // mở drawer search
    const [openDrawer, setOpenDrawer] = useState(false)

    // =========== TABLE && MẪU BÁO CÁO =================
    const [columns, setColumns] = useState<ProColumns<WasteHandoverRegistrationReport>[]>([
      {
        title: 'STT',
        dataIndex: 'stt',
        key: 'stt',
        fixed: 'left',
        width: 50,
        align: 'center',
      },
      {
        title: 'Mã đăng ký',
        dataIndex: 'wasteHandoverRegistrationCode',
        key: 'wasteHandoverRegistrationCode',
        fixed: 'left',
        width: 120,
        align: 'center',
        render: (text, record) => (
          <Link to={`${ROUTES.WASTE_HANDOVER_REGISTRATION.EDIT_REGISTRATION.LINK}/${record.wasteHandoverRegistrationId}`}>{text}</Link>
        )
      },
      {
        title: 'Nhà cung cấp',
        dataIndex: 'vendorFmt',
        key: 'vendorFmt',
        fixed: 'left',
        width: 300,
      },
      {
        title: 'Thời gian bàn giao',
        dataIndex: 'deliveredTime',
        key: 'deliveredTime',
        width: 180,
        align: 'center',
        render: (text, record) => {
          const deliveredTime = record?.deliveredTime;
          return deliveredTime ? moment(deliveredTime).format("DD/MM/YYYY HH:mm:ss") : '-'
        }
      },
      {
        title: 'Tên tài xế',
        dataIndex: 'driverName',
        key: 'driverName',
        width: 230,
      },
      {
        title: 'Số điện thoại',
        dataIndex: 'phone',
        key: 'phone',
        width: 100,
      },
      {
        title: 'Số xe',
        dataIndex: 'licensePlate',
        key: 'licensePlate',
        width: 100,
      },
      {
        title: 'Kết quả đào tạo an toàn',
        dataIndex: 'result',
        key: 'result',
        width: 180,
      },
      {
        title: 'Tình trạng phiếu',
        dataIndex: 'taskStatusName',
        key: 'taskStatusName',
        width: 130,
        align: 'center',
        render: (text, record) => {
          return <div className="w-full !text-[10px] !text-center font-medium !py-0.5 border rounded-sm"
            style={{
              borderColor: record.color + '80',
              color: record.color,
              backgroundColor: record.color + '1a'
            }}
          >{text}</div>
        }
      },
      {
        title: 'Trạng thái',
        dataIndex: 'actived',
        key: 'actived',
        width: 80,
        align: 'center',
        render: (text, record) => {
          if (record.actived === true) {
            return <CheckStatus className="!fill-[#389e0d] mx-auto" width="15" />
          } else if (record.actived === false) {
            return <CloseStatus width="15" className="!fill-red-500 mx-auto" />
          }
          return text
        }
      },
      {
        title: 'Ghi chú hủy phiếu',
        dataIndex: 'cancelReason',
        key: 'cancelReason',
        width: 350,
      },
    ])

    const [dataPaging, setDataPaging] = useState<SearchWasteHandoverRegistrationReport>(initialSearch);
    const [dataTable, setDataTable] = useState<WasteHandoverRegistrationReport[]>([])
    // disable nhập ngày khi chọn khác "Custom"
    const [disableDatePicker, setDisableDatePicker] = useState(false)
    const [loading, setLoading] = useState(true)
    // Dropdown nhà cung cấp
    const [listVendor, setListVendor] = useState<CommonModel[]>([])

    const getListCommom = async () => {
      if (!commonStore.listCommonDate.length) {
        await commonPresenter.getListCommonDate(commonStore)
      }
    }
    // search báo cáo
    const getDataTable = async (dataSearch: SearchWasteHandoverRegistrationReport) => {
      await reportPresenter.getWasteHandoverRegistrationReport(reportStore, dataSearch)
      if (reportStore.wasteHandoverRegistrationRes?.isSuccess) {
        setDataTable(reportStore.wasteHandoverRegistrationRes?.data)
        return reportStore.wasteHandoverRegistrationRes?.data
      }
      return []
    }

    const getDateByCommonDate = async (commonDate: string) => {
      setDisableDatePicker(true)
      await commonPresenter.getDateByCommonDate(commonStore, commonDate)
      if (commonStore.commonDate.fromDate) {
        searchForm.setFieldsValue({ deliveryDateFrom: dayjs(commonStore.commonDate.fromDate, "YYYY-MM-DD"), deliveryDateTo: dayjs(commonStore.commonDate.toDate, "YYYY-MM-DD") })
      }
    }

    // Dropdown nhà cung cấp
    const getDropdownVendor = async (keyword?: string) => {
      await commonPresenter.getDropdownVendor(commonStore, { keyword: keyword, takeNumber: 20, type: 'NCC_CT' })
      if (commonStore.commonRespone.isSuccess && commonStore.commonRespone.data.length) {
        setListVendor(commonStore.commonRespone.data)
      }
    }
    const searchVendor = useCallback(debounce(getDropdownVendor, 300), [])
    // Dropdown trạng thái luồn duyệt
    const getTaskStatus = async () => {
      if (!commonStore.dropdownTaskStatus.length) {
        await commonPresenter.getDropdownTaskStatus(commonStore)
      }
    }

    useEffect(() => {
      Promise.allSettled([
        getListCommom(),
        commonPresenter.getDropdownWasteMaterialTaskStatus(commonStore),
        getDropdownVendor(),
        getTaskStatus()

      ]).then(async () => {
        // Set mặc định là "Tháng này"
        if (commonStore.listCommonDate.length) {
          await getDateByCommonDate('ThisMonth')
          searchForm.setFieldsValue({ common: 'ThisMonth' })
        }
        setLoading(false)
      })
    }, []);
    // =================================================================================================
    // mẫu báo cáo
    const tableRef = useRef<ActionType>();
    const constDataName = 'BCDanhSachXeGiaoHang';
    const {
      isResizablePresent,
      setIsResizablePresent,
      resizableColumnSelect,
      columnsState,
      handleColumnsStateChange,
      templateReportModalRef,
      userReports,
      selectedReportId,
      templateReportModalProps,
      handleResize,
    } = useResizableColumns<WasteHandoverRegistrationReport>(columns, setColumns, constDataName);

    return (
      <PageWrapper
        breadcrumb={[{
          text: 'Báo cáo danh sách xe vào lấy chất thải'
        }]}
        extras={
          <>
            {isExport && <ExportButton loading={loading} onClick={async () => {
              setLoading(true);
              const { paging, ...exportData } = dataPaging;
              await reportPresenter.exportWasteHandoverRegistrationReport(exportData)
              setLoading(false);
            }} />}
            <CustomButton
              onClick={() => setOpenDrawer(true)}
              type="primary" color="#EFF4F9"
              className="!px-0 w-8"
            >
              <Filter className="!fill-primary" />
            </CustomButton>
          </>
        }
      >
        <BoxContainer>
          <CustomProTable<WasteHandoverRegistrationReport>
            bordered
            columns={columns}
            dataSource={dataTable}
            actionRef={tableRef}
            tableAlertRender={false}
            handleResize={handleResize}
            isResizablePresent={isResizablePresent}
            resizableColumnSelect={resizableColumnSelect}
            columnsState={{
              value: Object.keys(columnsState).length > 0 ? columnsState : undefined,
              onChange: (newColumnsState) => {
                handleColumnsStateChange(newColumnsState);
              },
            }}
            tableLayout='fixed'
            toolBarRender={() => [

              // nút lưu mẫu bc
              <SaveReportForm
                setIsResizablePresent={setIsResizablePresent}
                templateReportModalRef={templateReportModalRef}
                userReports={userReports}
                selectedReportId={selectedReportId}
                templateReportModalProps={templateReportModalProps}
              />,
            ]}
            rowKey="stt"
            pagination={{
              ...tablePagination(dataPaging, setDataPaging),
              total: reportStore.wasteHandoverRegistrationRes?.paging?.recordsTotal,
            }}
            request={async (params = {}, sort, filter) => {
              const data = await getDataTable({
                ...dataPaging,
                paging: {
                  ...dataPaging.paging,
                  orderBy:
                    Object.values(sort)[0] === "ascend"
                      ? `${Object.keys(sort)[0].split(",").pop()}`
                      : undefined,
                  orderByDesc:
                    Object.values(sort)[0] === "descend"
                      ? `${Object.keys(sort)[0].split(",").pop()}`
                      : undefined,
                },
              });
              if (Object.values(sort).length) {

                setDataPaging({
                  ...dataPaging,
                  paging: {
                    ...dataPaging.paging,
                    orderBy:
                      Object.values(sort)[0] === "ascend"
                        ? `${Object.keys(sort)[0].split(",").pop()}`
                        : undefined,
                    orderByDesc:
                      Object.values(sort)[0] === "descend"
                        ? `${Object.keys(sort)[0].split(",").pop()}`
                        : undefined,
                  },
                });
              }
              return {
                data: data,
                success: reportStore.wasteHandoverRegistrationRes?.isSuccess
              };

            }}
          />

        </BoxContainer>
        <SearchBox
          onClose={() => { setOpenDrawer(false) }}
          className="lg:!w-[50%]"
          open={openDrawer}
          footer={
            <CustomButton
              htmlType="submit"
              className="my-auto ml-auto"
              type="primary"
              icon={<HiSearch />}
              onClick={() => {
                searchForm.submit();
              }}
            >
              Tìm kiếm
            </CustomButton>
          }
        >
          <SearchForm
            form={searchForm}
            onFinish={(values) => {
              const valueClone = cloneDeep(values)
              // convert lại from date to date
              const deliveryDateFrom = valueClone?.deliveryDateFrom ? valueClone.deliveryDateFrom?.format("YYYY-MM-DD") : undefined
              const deliveryDateTo = valueClone?.deliveryDateTo ? valueClone.deliveryDateTo?.format("YYYY-MM-DD") : undefined
              Object.assign(valueClone, { deliveryDateFrom, deliveryDateTo })
              // Map vendorNumber thành vendorNumbers (array)
              if (valueClone.vendorNumber) {
                valueClone.vendorNumbers = Array.isArray(valueClone.vendorNumber) ? valueClone.vendorNumber : [valueClone.vendorNumber]
                delete valueClone.vendorNumber
              }
              // Map taskStatusCategory thành taskStatusCategories (array)
              if (valueClone.taskStatusCategory) {
                valueClone.taskStatusCategories = Array.isArray(valueClone.taskStatusCategory) ? valueClone.taskStatusCategory : [valueClone.taskStatusCategory]
                delete valueClone.taskStatusCategory
              }
              // Đảm bảo actived luôn có giá trị
              // if (valueClone.actived === undefined || valueClone.actived === null) {
              //   valueClone.actived = true
              // }
              console.log('valueClone con idmme nayf', valueClone);

              // bỏ các giá trị rỗng null và trim giá trị
              removeEmptyValues(valueClone)
              const dataSearch: SearchWasteHandoverRegistrationReport = { paging: { ...dataPaging.paging, pageIndex: 1 }, ...valueClone }
              setDataPaging(dataSearch)
              setOpenDrawer(false)
              tableRef.current?.reload()
            }}
          >
            {/* Mã đăng ký */}
            <SearchItem name={'wasteHandoverRegistrationCode'} label={'Mã đăng ký'}>
              <Input />
            </SearchItem>
            {/* Nhà cung cấp */}
            <SearchItem name={'vendorNumber'} label={'Nhà cung cấp'}>
              <Select
                mode="multiple"
                popupMatchSelectWidth={false}
                options={listVendor.map(item => ({ value: item.key, label: item.value }))}
                allowClear showSearch
                filterOption={false}
                onSearch={(value) => searchVendor(value || undefined)}
                placeholder="Chọn nhà cung cấp"
              />
            </SearchItem>
            {/* Số xe */}
            <SearchItem name={'licensePlate'} label={'Số xe'}>
              <Input />
            </SearchItem>
            {/* Tình trạng phiếu */}
            {/* <SearchItem name={'taskStatusCategory'} label={'Tình trạng phiếu'}>
              <Select
                mode="multiple"
                options={commonStore.dropdownTaskStatus}
                fieldNames={{ label: 'value', value: 'key' }}
                filterOption={false}
                allowClear
                placeholder={'-- Tất cả --'}
              />
            </SearchItem> */}
            <SearchItem name={'taskStatusCategories'} label={'Tình trạng phiếu'}>
              <Select
                allowClear
                mode="multiple"
                placeholder={'-- Tất cả --'}
                options={commonStore.dropdownWasteMaterialTaskStatus}
                fieldNames={{ label: "value", value: 'key' }}
              // placeholder={t('place-holder.please-select')}
              />
            </SearchItem>
            {/* Thời gian bàn giao */}
            <SearchItem name="common" initialValue={'ThisMonth'} label={'Thời gian bàn giao'} start>
              <Select options={commonStore.listCommonDate} fieldNames={{ label: 'value', value: 'key' }} onChange={async (value) => {
                if (value && value !== "Custom") {
                  getDateByCommonDate(value)
                } else {
                  setDisableDatePicker(false)
                  searchForm.setFieldsValue({ deliveryDateFrom: undefined, deliveryDateTo: undefined })
                }
              }} />
            </SearchItem>
            {/* Trạng thái phiếu */}
            <SearchItem name={'actived'} label={'Trạng thái phiếu'}>
              <Select options={dropdownActive}
                allowClear filterOption={false}
                placeholder={'-- Tất cả --'}
              />
            </SearchItem>
            {/* Từ ngày */}
            <SearchItem
              initialValue={dayjs().startOf('month')}
              name={'deliveryDateFrom'} label={'Từ ngày'}
              start
              dependencies={['deliveryDateTo']}
              rules={[
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (value || getFieldValue('deliveryDateTo')) {
                      return Promise.resolve()
                    }
                    return Promise.reject(new Error('Chưa nhập giá trị "Từ ngày".'));;
                  },
                })
              ]}
            >
              <DatePicker changeOnBlur disabled={disableDatePicker} format={DATE_FORMAT_DEFAULT} className="w-full" />
            </SearchItem>
            {/* Đến ngày */}
            <SearchItem
              initialValue={dayjs().endOf('month')}
              name={'deliveryDateTo'} label={'Đến ngày'}
              dependencies={['deliveryDateFrom']}
              rules={[
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (value || getFieldValue('deliveryDateFrom')) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error('Chưa nhập giá trị "Đến ngày".'));
                  },
                })
              ]}
            >
              <DatePicker changeOnBlur disabled={disableDatePicker} format={DATE_FORMAT_DEFAULT} className="w-full" />
            </SearchItem>
          </SearchForm>
        </SearchBox>
      </PageWrapper>
    )
  })
}

export default createListRegistrationWaste